var _path, _path2, _path3, _path4, _path5, _path6, _rect, _circle, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H1.0003C0.983613 23.5887 1.65489 21.2304 2.92286 19.2457C3.51653 18.3244 4.24065 17.5097 5.06867 16.8314C5.88581 16.1567 6.80191 15.6346 7.77886 15.287C7.5778 15.0456 7.3598 14.7619 7.17537 14.5145C6.43028 13.5482 5.87335 12.4295 5.53792 11.2253C5.36967 11.1591 5.21581 11.0562 5.08588 10.9231C4.90751 10.6059 4.82367 10.2372 4.84571 9.86689C4.89043 9.66892 4.97195 9.48285 5.08533 9.31997C5.19871 9.1571 5.34157 9.02083 5.50524 8.91945C5.68855 7.58809 6.26476 6.35615 7.14823 5.40677C8.02639 4.49232 9.20214 3.98724 10.4219 4.00044C11.6626 3.98306 12.8624 4.47928 13.775 5.38723C14.6867 6.313 15.2963 7.5326 15.5129 8.86367C15.703 8.95648 15.8715 9.09412 16.0059 9.26647C16.1403 9.43882 16.2373 9.6415 16.2897 9.85964C16.3125 10.2377 16.2287 10.6144 16.0495 10.9401C15.9026 11.0863 15.7238 11.1901 15.5298 11.2417C15.3839 12.2188 14.9709 12.7687 14.0266 13.9756L13.7531 14.327L13.5687 14.5142C13.3676 14.7134 13.1441 14.9366 12.9092 15.154C17.0998 16.4576 20 20.8994 20 26Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.53635C14.0898 7.53635 17 6.77401 17 5.83361C17 4.89321 14.0898 4.13086 10.5 4.13086C6.91014 4.13086 4 4.89321 4 5.83361C4 6.77401 6.91014 7.53635 10.5 7.53635Z",
    fill: "#4E4E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5005 7.49079C14.0668 7.49079 16.958 6.74886 16.958 5.83365C16.958 4.91844 14.0668 4.17651 10.5005 4.17651C6.93409 4.17651 4.04297 4.91844 4.04297 5.83365C4.04297 6.74886 6.93409 7.49079 10.5005 7.49079Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.87234C6 4.87234 7.66169 0.936599 8.73825 1.0045C9.4255 1.06119 10.0917 1.28506 10.6862 1.6591C10.6862 1.6591 11.9173 0.936599 12.9127 1.0045C13.9082 1.07241 15 5 15 5",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76242 5.51199C8.96492 5.52438 8.16736 5.49224 7.37335 5.4157C7.11896 5.38986 6.86778 5.33807 6.62364 5.26114C6.37373 5.18005 6.32126 5.10404 6.30376 5.0635C6.23104 4.83681 6.24899 4.59023 6.35374 4.37682C6.4018 4.26383 6.45949 4.1553 6.52618 4.05249L14.8155 4.13864C14.875 4.23908 14.9228 4.34622 14.9579 4.45791C14.9908 4.55558 15.0027 4.65924 14.9929 4.76197C14.9798 4.85969 14.9328 4.9495 14.8604 5.01535C14.7361 5.1052 14.5935 5.16579 14.4431 5.19272C14.1594 5.26388 13.8714 5.31636 13.5809 5.34982C12.6621 5.4498 11.7386 5.50054 10.8145 5.50185L9.76242 5.51199Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3961 8.42484C18.6458 11.0932 16.6483 13.4622 13.9347 13.7161C11.2211 13.9699 8.81886 12.0126 8.56922 9.34423C8.31957 6.67585 10.317 4.30688 13.0307 4.053C15.7443 3.79912 18.1465 5.75646 18.3961 8.42484Z",
    fill: "#4E4E4E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5605,
    y: 10.7412,
    width: 6.143,
    height: 2.96775,
    rx: 1,
    transform: "rotate(48.1999 17.5605 10.7412)",
    fill: "#4E4E4E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5011,
    cy: 8.97619,
    r: 3.62143,
    transform: "rotate(-5.34491 13.5011 8.97619)",
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.8654,
    y1: 12.1015,
    x2: 20.0117,
    y2: 15.2313,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspector);
export default __webpack_public_path__ + "static/media/inspector.3da3e5f61c2c51e15d244a1569a3e2d5.svg";
export { ForwardRef as ReactComponent };